import { render, staticRenderFns } from "./EditorTexto.vue?vue&type=template&id=d7a69536&scoped=true&"
import script from "./EditorTexto.vue?vue&type=script&lang=js&"
export * from "./EditorTexto.vue?vue&type=script&lang=js&"
import style0 from "@/../public/css/components/vue2-editor.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a69536",
  null
  
)

export default component.exports